module.exports = __webpack_public_path__ + "img/index_icon_01.a2de93ba.png";